import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

const InfosRow = ({ icon, children, columns, label }) => {
  return (
    <>
      <S.Wrapper>
        <S.TitleWrapper>
          <S.TitleContent>
            <GetIcon name={icon} color="#ffffff" size="s" />
            <S.Title>{label}</S.Title>
          </S.TitleContent>
        </S.TitleWrapper>
        <S.ContentWrapper>
          <S.Content columns={columns}>{children}</S.Content>
        </S.ContentWrapper>
      </S.Wrapper>
    </>
  );
};
export default InfosRow;
